import { render, staticRenderFns } from "./coursework-instructions.vue?vue&type=template&id=3299cd29&scoped=true"
import script from "./coursework-instructions.vue?vue&type=script&setup=true&lang=ts"
export * from "./coursework-instructions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./coursework-instructions.vue?vue&type=style&index=0&id=3299cd29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3299cd29",
  null
  
)

export default component.exports